"use client";

import React, { useEffect } from "react";
import clsx from "clsx";
import styles from "./STDrawer.module.css";
import { getLenis } from "../STSmoothScroll";
import { Icons } from "../../const/icons";

export const STDrawer = ({
  open,
  onClose,
  children,
  position = "right", // right | left | top | bottom
  width = "450px",
  height = "300px",
  overlay = true,
  title,
}) => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "auto";
  }, [open]);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape" && open) {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, [open, onClose]);

  useEffect(() => {
    const lenis = getLenis();

    if (open) {
      lenis?.stop();
    } else {
      lenis?.start();
    }

    return () => {
      lenis?.start();
    };
  }, [open]);

  return (
    <>
      {/* Overlay */}
      {overlay && (
        <div
          className={clsx(styles.overlay, open && styles.show)}
          onClick={onClose}
        />
      )}

      {/* Drawer */}
      <div
        className={clsx(
          styles.drawer,
          styles[position],
          open && styles.open,
          "position-fixed d-flex flex-column bg-white transition-smooth w-100 h-100",
        )}
        style={{
          maxWidth:
            position === "left" || position === "right" ? width : "100%",
          maxHeight:
            position === "top" || position === "bottom" ? height : "100%",
        }}
      >
        <div
          className={clsx(
            styles.header,
            "d-flex align-items-center justify-content-between space-xs-pb",
          )}
        >
          <h5 className={clsx(styles.title, "mb-0")}>{title}</h5>
          <button
            aria-label="Close"
            className={clsx(
              styles.closeBtn,
              "cursor-pointer border-0 transition-smooth d-flex align-items-center justify-content-center flex-shrink-0",
            )}
            onClick={onClose}
          >
            {Icons.closeIcon}
          </button>
        </div>

        {/* Content */}
        <div className={clsx(styles.content)} data-lenis-prevent>
          {children}
        </div>
      </div>
    </>
  );
};
